import type React from 'react';

import { Card, Heading, Icon, Paragraph } from '@zillow/constellation-10';

import BackAndSubmit from '../BackAndSubmit';
import { GET_STARTED } from '../SectionWrapper/constants';
import type { Lease } from '../../models';

type Props = {
  label: string;
  subLabel: string;
  subLabelDescription: string;
  children?: React.ReactNode;
  transitionName: string;
  getPrevious: () => void;
  getStartedClick: () => void;
  hasPrevious: boolean;
  showComponentIntro: boolean;
  icon: React.ReactNode;
  lease: Lease;
};

function updateTestingHelper(showComponentIntro) {
  if (typeof window !== 'undefined') {
    // @ts-ignore
    const testingObj = window.__TESTING__ || {};

    testingObj.isCategoryIntro = showComponentIntro;
    // @ts-ignore
    window.__TESTING__ = testingObj;
  }
}

function SectionCategoryIntro(props: Props) {
  const {
    label,
    subLabel,
    getPrevious,
    subLabelDescription,
    children,
    hasPrevious,
    getStartedClick,
    showComponentIntro,
    icon,
    ...rest
  } = props;

  updateTestingHelper(showComponentIntro);

  return (
    <div key={String(!showComponentIntro)}>
      {showComponentIntro ? (
        <>
          <Card tone="neutral" elevated={false} css={{ padding: 'loose' }}>
            <Icon size="lg" role="img">
              {icon}
            </Icon>
            <Heading
              level={3}
              fontFamily="heading-alt"
              css={{
                textStyle: 'responsive.heading-sm',
                marginTop: 'tighter',
                marginBottom: 'tighter',
              }}
            >
              {label}
            </Heading>
            <Paragraph>{subLabel}</Paragraph>
            <Paragraph>
              <strong>{subLabelDescription}</strong>
            </Paragraph>
          </Card>
          <BackAndSubmit
            hasNext
            hasPrevious={hasPrevious}
            hasFieldChanged={false}
            getPrevious={getPrevious}
            submitHandler={getStartedClick}
            submitText={GET_STARTED}
            showBack={hasPrevious}
            renderModalView={false}
            {...rest}
          />
        </>
      ) : (
        children
      )}
    </div>
  );
}

export default SectionCategoryIntro;
